export default __webpack_public_path__ + "b7b2164ef54b540dc60a4e3f41375cdd.png";